import {useIsomorphicLayoutEffect} from '../../../../common/useIsomorphicLayoutEffect.hook';
import useTypedSelector from '../../../../common/useTypedSelector';
import {useWrapRef} from '../../../../common/useWrapRef.hook';
import {ContentHomeTabType} from '../type';

export function useInitializeScrollTop(tabType: ContentHomeTabType) {
  const needAutoScroll = useTypedSelector(
    state => state.contentHome.needAutoScroll
  );
  // needAutoScroll 값은 "첫 화 보기" 탭에서 자동 스크롤 이후 바뀌는 값이다.
  // 탭이 바뀌면 최초 한 번만 스크롤을 초기화 해야 하는데,
  // 디펜던시에 입력하면 두 번 호출되기 때문에 useRef 를 사용해 관리합니다.
  const needAutoScrollRef = useWrapRef(needAutoScroll);

  useIsomorphicLayoutEffect(() => {
    const isPreviewTab = tabType === ContentHomeTabType.preview;

    if (isPreviewTab && needAutoScrollRef.current) return;

    window.scrollTo(0, 0);
  }, [tabType]);
}
